// SplashScreen — auth-in-progress.
// Faithful port of the design bundle (screens-auth.jsx · AuthSplash):
// pulsing logo + skeleton progress bar, shown while POST /auth is in flight.
import { Icon, LogoMark, t } from '../design'

export function SplashScreen() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, padding: 24, position: 'relative' }}>
      <div style={{ animation: 'pulse 1.6s ease-in-out infinite' }}>
        <LogoMark size={72} />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div className="t-display" style={{ fontSize: 26, letterSpacing: '-0.02em' }}>Pilotools</div>
        <div className="t-caption" style={{ marginTop: 4 }}>{t('auth.splash.tagline')}</div>
      </div>
      <div style={{ width: 160, height: 5, borderRadius: 3, background: 'var(--surface-2)', overflow: 'hidden', marginTop: 6 }}>
        <div className="skel" style={{ width: '55%', height: '100%' }} />
      </div>
      <div className="row middle gap-2" style={{ position: 'absolute', bottom: 22, color: 'var(--text-3)' }}>
        <Icon.Telegram size={13} sw={2} />
        <span className="t-caption" style={{ color: 'var(--text-3)' }}>{t('auth.splash.sub')}</span>
      </div>
    </div>
  )
}
